// theme
import { ThemeColorPresets } from '../components/settings/type';
import palette from '../theme/palette';
// @type

// ----------------------------------------------------------------------

export const colorPresets = [
  // DEFAULT
  {
    name: 'default',
    ...palette.light.primary,
  },
  // PURPLE
  {
    name: 'purple',
    lighter: '#767ca5',
    light: '#274D73',
    main: '#1E284A',
    dark: '#0A2233',
    darker: '#000000',
    contrastText: '#fff',
  },
  // CYAN
  {
    name: 'cyan',
    lighter: '#D1FFFC',
    light: '#76F2FF',
    main: '#1CCAFF',
    dark: '#0E77B7',
    darker: '#053D7A',
    contrastText: palette.light.grey[800],
  },
  // BLUE
  {
    name: 'blue',
    lighter: '#767ca5',
    light: '#174E76',
    main: '#1E284A',
    dark: '#0A2233',
    darker: '#052033', //'#000000',
    contrastText: '#fff',
  },
  // ORANGE
  {
    name: 'orange',
    lighter: '#FEF4D4',
    light: '#FED680',
    main: '#fda92d',
    dark: '#B66816',
    darker: '#793908',
    contrastText: palette.light.grey[800],
  },
  // RED
  {
    name: 'red',
    lighter: '#FFE3D5',
    light: '#FFC1AC',
    main: '#FF3030',
    dark: '#B71833',
    darker: '#7A0930',
    contrastText: '#fff',
  },
  // VIOLET
  {
    name: 'violet',
    lighter: '#4300bf26',
    light: '#174E76',
    main: '#4300BF',
    dark: '#32008f',
    darker: '#180045',
    contrastText: '#fff',
  },
];

export const defaultPreset = colorPresets[0];
export const purplePreset = colorPresets[1];
export const cyanPreset = colorPresets[2];
export const bluePreset = colorPresets[3];
export const orangePreset = colorPresets[4];
export const redPreset = colorPresets[5];
export const violetPreset = colorPresets[6];

export default function getColorPresets(presetsKey: ThemeColorPresets) {
  return {
    default: defaultPreset,
    purple: purplePreset,
    cyan: cyanPreset,
    blue: bluePreset,
    orange: orangePreset,
    red: redPreset,
    violet: violetPreset,
  }[presetsKey];
}
